// LanguageContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // const { t, i18n } = useTranslation();
  const { i18n } = useTranslation();
  const storedLanguage = sessionStorage.getItem("language");
  const [language, setLanguage] = useState(storedLanguage || "ar");

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language.toLowerCase());
    }
  }, [i18n, language]);

  // const changeLanguage2 = (newLanguage) => {
  //   setLanguage(newLanguage);
  //   sessionStorage.setItem("language", newLanguage);
  // };

  const changeLanguage = () => {
    if (language === "en") {
      setLanguage("ar");
      i18n.changeLanguage("ar");
      sessionStorage.setItem("language", "ar");
    } else if (language === "ar") {
      setLanguage("en");
      i18n.changeLanguage("en");
      sessionStorage.setItem("language", "en");
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  return useContext(LanguageContext);
};
